import { render } from "./OrganizationChartNode.vue?vue&type=template&id=04cb16ca"
import script from "./OrganizationChartNode.vue?vue&type=script&lang=js"
export * from "./OrganizationChartNode.vue?vue&type=script&lang=js"
script.render = render

export default script